import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../base/base.service';
import { DocumentTypeSchema } from '@schemas/core';
import { IToSelect } from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeService extends BaseService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  find(): Observable<DocumentTypeSchema[]> {
    return this.http.get<DocumentTypeSchema[]>(
      `${this.API_URL}/document-types/`,
    );
  }

  toSelect(documentTypes: DocumentTypeSchema[]): IToSelect[] {
    return documentTypes.map((a) => ({ id: a.id, description: a.code }));
  }
}
